// hooks/useLabelsVisibility.ts
import { useEffect, useState } from 'react';
import { StickerFragment } from '@/graphql';

export const useLabelsVisibility = (
  bonus?: number,
  discount?: number,
  labels: StickerFragment[] = []
) => {
  const [showAllLabels, setShowAllLabels] = useState(false);
  const [topSectionHeight, setTopSectionHeight] = useState(0);
  const [conditionalRenderCount, setConditionalRenderCount] = useState(0);

  const renderConditionals = () => {
    let count = 0;
    if (bonus !== undefined && bonus !== null && bonus !== 0) {
      count++;
    }
    if (discount) {
      count++;
    }
    return count;
  };

  useEffect(() => {
    setConditionalRenderCount(renderConditionals());
  }, [bonus, discount]);

  const handleToggleLabels = () => {
    setShowAllLabels(!showAllLabels);
    if (!showAllLabels) {
      setTopSectionHeight(24);
    } else {
      setTopSectionHeight(0);
    }
  };

  let visibleLabels: StickerFragment[] = [];
  let showToggleButton = false;

  if (conditionalRenderCount >= 2) {
    visibleLabels = showAllLabels ? labels || [] : [];
    showToggleButton = (labels || []).length > 0;
  } else if (conditionalRenderCount === 1) {
    visibleLabels = showAllLabels ? labels || [] : labels?.slice(0, 1) || [];
    showToggleButton = (labels || []).length > 1;
  } else {
    visibleLabels = showAllLabels ? labels || [] : labels?.slice(0, 2) || [];
    showToggleButton = (labels || []).length > 2;
  }

  return {
    visibleLabels,
    showAllLabels,
    handleToggleLabels,
    topSectionHeight,
    showToggleButton,
  };
};
